import { ChevronLeft, ChevronRight } from 'lucide-react';
import { currentYearMonth, shiftMonth } from '@/lib/date';
import { formatMonthLabel } from '@/lib/format';

interface MonthSwitcherProps {
  value: string;
  onChange: (month: string) => void;
}

/** Nunca deja avanzar más allá del mes actual — no tiene sentido "entrar" a un mes futuro. */
export function MonthSwitcher({ value, onChange }: MonthSwitcherProps) {
  const atCurrentMonth = value >= currentYearMonth();

  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-border bg-card px-1 py-1">
      <button
        type="button"
        className="rounded p-1.5 text-muted-foreground hover:bg-accent hover:text-foreground"
        onClick={() => onChange(shiftMonth(value, -1))}
        aria-label="Mes anterior"
      >
        <ChevronLeft size={16} />
      </button>
      <span className="min-w-[9rem] text-center text-sm font-medium">{formatMonthLabel(value)}</span>
      <button
        type="button"
        className="rounded p-1.5 text-muted-foreground hover:bg-accent hover:text-foreground disabled:pointer-events-none disabled:opacity-30"
        onClick={() => onChange(shiftMonth(value, 1))}
        disabled={atCurrentMonth}
        aria-label="Mes siguiente"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
